import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, brand } from '../mock';

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Build smart link: hash links go to landing root + hash
  const renderLink = (l, onClick) => {
    if (l.href.startsWith('/#')) {
      return (
        <Link key={l.label} to={l.href} onClick={onClick} className="text-ink/75 hover:text-ink transition-colors">
          {l.label}
        </Link>
      );
    }
    return (
      <Link key={l.label} to={l.href} onClick={onClick} className="text-ink/75 hover:text-ink transition-colors">
        {l.label}
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-50">
      <div className="mx-auto max-w-6xl px-4 sm:px-5 py-3 sm:py-4">
        <nav className="flex items-center justify-between rounded-2xl bg-white/75 backdrop-blur-md border border-ink-10 pl-3 pr-2 py-2 sm:pl-4 sm:pr-3 sm:py-2.5 soft-card gap-3">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-7 h-7 rounded-md bg-gradient-to-br from-[#E08C5F] to-[#C2603A] flex items-center justify-center">
              <span className="serif-display text-white text-lg leading-none">E</span>
            </div>
            <span className="text-[16px] sm:text-[17px] font-medium tracking-tight">{brand.name}</span>
          </Link>

          <div className="hidden md:flex items-center gap-5 lg:gap-7 text-[14px]">
            {navLinks.map((l) => renderLink(l))}
          </div>

          <div className="flex items-center gap-2">
            <Link
              to="/#contact"
              className="hidden sm:inline-flex btn-primary items-center rounded-xl px-3.5 lg:px-4 py-2 text-[13px] lg:text-[14px] font-medium whitespace-nowrap"
            >
              Contact us
            </Link>

            <button
              className="md:hidden p-2 rounded-md hover:bg-black/5"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </nav>

        {open && (
          <div className="md:hidden mt-2 rounded-2xl bg-white border border-ink-10 soft-card p-3 fade-up">
            {navLinks.map((l) => (
              <Link
                key={l.label}
                to={l.href}
                onClick={() => setOpen(false)}
                className="block px-3 py-2.5 rounded-lg hover:bg-[#FBF2E8] text-sm text-ink/80"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/#contact"
              onClick={() => setOpen(false)}
              className="mt-2 block text-center btn-primary rounded-xl px-4 py-2.5 text-sm font-medium"
            >
              Contact us
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
